import React, {Fragment} from 'react'

 const About = () => {
    return (
        <Fragment>
            <h1>About Us</h1>
            <p>This is an App for finding github users.</p>
            <p>Version: 1.0.0</p>
        </Fragment>
    )
}
export default About;